export enum CancellationPolicyType {
	None = 0,
	Flexible = 1,
	Moderate = 2,
	Strict = 3,
	NonRefundable = 4
}
